import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Comunicado } from '../base/vo/comunicado';
import { ComunicadosService } from './comunicados.service';


@Component({
    selector: 'app-comunicados',
    templateUrl: './comunicados.component.html',
    styleUrls: ['./comunicados.component.css']
})
export class ComunicadosComponent implements OnInit, AfterViewChecked {

    public comunicados: Comunicado[] = [];
    private indices: boolean[] = [];
    private indiceComunicadoExpandido: number;
    private indice = 0;

    constructor(private comunicadosService: ComunicadosService,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        scrollTo(0, 0);
        this.buscarComunicados();
    }

    ngAfterViewChecked() {
        this.darFocoComunicadoSelecionado();
    }

    private buscarComunicados(): void {
        this.comunicadosService.buscarComunicados()
            .subscribe(
                res => {
                    this.comunicados = res.data.list;
                    this.obterComunicadoSelecionado();
                },
                err => console.log('Mensagem de erro')
            );
    }

    private obterComunicadoSelecionado() {
        this.activatedRoute.fragment.subscribe(
            f => this.obterIndiceComunicadoSelecionado(f)
        );
    }

    private obterIndiceComunicadoSelecionado(comunicado) {
        let indice = 0;
        if (comunicado) {
            indice = this.comunicados.map(c => c.id).indexOf(comunicado.id);
        }
        this.ocultarOuExpandir(indice);
    }

    private isExpandido(indice: number) {
        return this.indices[indice];
    }

    private getBordaLadoEsquerdo(indice: number): string {
        return this.indices[indice] ? 'comunicado-exapandido-borda' : 'comunicado-oculto-borda';
    }

    private ocultarOuExpandir(indice): void {
        indice = indice || 0;
        this.fecharComunicadoExpandido(indice);
        this.indices[indice] = !this.indices[indice];
        this.indice = indice;
    }

    private getCirculoTimeline(indice: number) {
        return this.indices[indice] ? 'expandido' : 'oculto';
    }

    private fecharComunicadoExpandido(indice: number) {
        if (this.indiceComunicadoExpandido === indice) {
            this.indiceComunicadoExpandido = -1;
        } else {
            this.indices[this.indiceComunicadoExpandido] = false;
            this.indiceComunicadoExpandido = indice;
        }
    }

    private darFocoComunicadoSelecionado() {
        const idComunicadoSelecionado = document.getElementById((`comunicado${this.indice + 1}`).toString());

        if (idComunicadoSelecionado) {
            idComunicadoSelecionado.focus();
            scrollTo(0, 0);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/comunicados/comunicados.component.ts